export enum PriceAdjustmentTypes_Enum {
  "Price Per Square Foot" = 1,
  "Percentage" = 2
}

